import React from 'react';
import { Stack } from '@mantine/core';
import { SessionInfoCard } from '../SessionInfoCard/SessionInfoCard';
import { SessionControls, SessionStats } from '../../SessionId';
import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import type { DeviceConnectionStatus, Device } from '@types';

interface SessionBoxProps {
  session: DeviceConfigurationApi;
  appRequirements: { vr: boolean; sensor: boolean };
  allDevices: Device[];
  connectionStatus: Record<string, DeviceConnectionStatus>;
  isLoading: boolean;
}

export const SessionBox: React.FC<SessionBoxProps> = ({
  session,
  appRequirements,
  allDevices,
  connectionStatus,
  isLoading,
}) => {
  return (
    <Stack gap='sm'>
      <SessionInfoCard
        patientCode={session?.patientCode}
        patientId={session?.patient_id}
        appType={session?.type}
        scenario={session?.scenario}
        videoName={session?.video?.name}
        source={session?.video?.category ?? session?.video?.product_name}
        isLoading={isLoading}
      />

      <SessionControls
        session={session}
        appRequirements={appRequirements}
        allDevices={allDevices}
        connectionStatus={connectionStatus}
      />

      <SessionStats session={session} />
    </Stack>
  );
};

SessionBox.displayName = 'SessionBox';
